import { apiSlice } from './apiSlice'

/**
 * Sales Control › Invoice PRINT preview queries (Access Invoice-screen toolbar).
 * New slice — conflict-free with saleInvoiceApi.ts (owned by another agent).
 *
 *   getInvoiceCustomsPrintPreview  → GET /sale-invoices/print/customs/preview
 *   getInvoiceCustomerPrintPreview → GET /sale-invoices/print/customer/preview
 *   getInvoicePklPrintPreview      → GET /sale-invoices/print/pkl/preview
 *
 * Each returns { title, html, message }. 422 detail = user-facing English
 * message (invoice not found / no rows). keepUnusedDataFor: 0 (always refetch).
 */
type PrintPreview = { title: string; html: string; message?: string }

/** PKL chooser cbPkl_type combo → mode param. */
export type PklMode = 'OnSpot' | 'OnSpotDone' | 'Direct'

const saleInvoicePrintApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Print — Customs: rpCtrlSalesInvCustoms (filter customs_inv_no).
    getInvoiceCustomsPrintPreview: builder.query<PrintPreview, string>({
      query: (customsInvNo) => ({
        url: '/sale-invoices/print/customs/preview',
        params: { customsInvNo },
      }),
      keepUnusedDataFor: 0,
    }),
    // Print — Customer: rpCtrlSalesInvCustomer (+ bonded/KNQ variant).
    getInvoiceCustomerPrintPreview: builder.query<PrintPreview, string>({
      query: (customerInvoiceNumber) => ({
        url: '/sale-invoices/print/customer/preview',
        params: { customerInvoiceNumber },
      }),
      keepUnusedDataFor: 0,
    }),
    // PKL: chooser mode (cbPkl_type) selects the report family/variant.
    getInvoicePklPrintPreview: builder.query<
      PrintPreview,
      { customerInvoiceNumber: string; mode: PklMode }
    >({
      query: ({ customerInvoiceNumber, mode }) => ({
        url: '/sale-invoices/print/pkl/preview',
        params: { customerInvoiceNumber, mode },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetInvoiceCustomsPrintPreviewQuery,
  useLazyGetInvoiceCustomerPrintPreviewQuery,
  useLazyGetInvoicePklPrintPreviewQuery,
} = saleInvoicePrintApi

export default saleInvoicePrintApi
